import getO365ShellShim from '../utils/getO365ShellShim';
export default function closeFlexPane(flexPaneId) {
    var shim = getO365ShellShim();
    if (shim) {
        shim.FlexPane.CloseFlexPaneForProvider(flexPaneId);
    }
}
//# sourceMappingURL=closeFlexPane.js.map